export const SearchInventoryAnalysisPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">재고 분석 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select w-150px">
                                <option>주문필요</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">검색어</label>
                            <div className="frm_field">
                                <select className="form-select w-150px">
                                    <option>분석</option>
                                </select>
                                <input type="text" className="form-control w-250px" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">재고 목록(<span>23</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                        <button className="btn btn-outline-primary ms-40px">
                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_gear_blue.png"} alt="" />수식설정
                        </button>
                    </div>
                </div>

                <table className="table table-bordered my_table">
                    <thead>
                        <tr>
                            <th style={{ width: "4.4%" }}>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </th>
                            <th>벤더</th>
                            <th>카테고리</th>
                            <th>품목</th>
                            <th>규격</th>
                            <th>단위</th>
                            <th>현재재고량</th>
                            <th>총 입고량</th>
                            <th>총 출고량</th>
                            <th>주문필요여부</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">10</td>
                            <td className="text-center">5</td>
                            <td className="text-center">주문필요</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk Solo</td>
                            <td className="text-center">Solo</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">1</td>
                            <td className="text-center">17</td>
                            <td className="text-center">-</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">10</td>
                            <td className="text-center">5</td>
                            <td className="text-center">주문필요</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk Solo</td>
                            <td className="text-center">Solo</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">1</td>
                            <td className="text-center">17</td>
                            <td className="text-center">-</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">10</td>
                            <td className="text-center">5</td>
                            <td className="text-center">주문필요</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk Solo</td>
                            <td className="text-center">Solo</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">1</td>
                            <td className="text-center">17</td>
                            <td className="text-center">-</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">10</td>
                            <td className="text-center">5</td>
                            <td className="text-center">주문필요</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk Solo</td>
                            <td className="text-center">Solo</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">1</td>
                            <td className="text-center">17</td>
                            <td className="text-center">-</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">MS</td>
                            <td className="text-center">Compact</td>
                            <td className="text-center">S1-WIN…</td>
                            <td className="text-center">TNA-00022</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">10</td>
                            <td className="text-center">5</td>
                            <td className="text-center">주문필요</td>
                        </tr>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                    />
                                </div>
                            </td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk</td>
                            <td className="text-center">AnyDesk Solo</td>
                            <td className="text-center">Solo</td>
                            <td className="text-center">OS</td>
                            <td className="text-center">Win7</td>
                            <td className="text-center">1</td>
                            <td className="text-center">17</td>
                            <td className="text-center">-</td>
                        </tr>
                    </tbody>
                </table>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}